<template>
  <BootstrapModal class="MarkAsBeingShipped"
    v-on="$listeners"

    @save="saveTrackAndTraceAndMarkAsShipped"
  >
    <template #title>
      <i class="nc-icon nc-single-02"></i>
      Markeer <b>bestelling {{ order.orderNumber }}</b> als verzonden
    </template>


    <FormInput
      class="form-element"
      v-model="shipmentTrackAndTrace"

      id="name"
      label="Track en trace"

      fieldName="name"
    />

    <template #close>
      <span></span>
    </template>
    <template #save>
      Markeer als verzonden en bewaar Track en Trace
    </template>
    
  </BootstrapModal>
</template>

<script>

import FormInput from "../../../components/Inputs/FormInput.vue"
import BootstrapModal from "../BootstrapModal.vue"

export default {
  components: {
    FormInput,
    BootstrapModal,
  },
  props: {
    order: Object,
    callback: Function,
  },
  data() {
    return {
      shipmentTrackAndTrace: "",
    }
  },
  methods: {
    async saveTrackAndTraceAndMarkAsShipped() {
      await this.$handlePromise(async () => {
        await this.axios.post(`/api/orders/${this.order.uid}/shipments`, { shipmentTrackAndTrace: this.shipmentTrackAndTrace })
        this.callback && await this.callback()

        this.$success("Succesvol gemarkeerd als verzonden en track en trace opgeslagen!")
        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped>

.nc-icon {
  transform: translateY(2px);
}

.MarkAsBeingShipped {
  flex-basis: 500px;  
}

</style>
